import { SidebarMenuItem, TopLevelNavigation, TopLevelNavigationItem } from '@apparatix/types';
import { AppStore } from '@apparatix/stores/AppStore';
import { useRouter } from 'vue-router';

export const useBackendDataConverter = () => {
  const router = useRouter();
  const generateUrl = (isIframed: boolean, url: string): string => {
    if (isIframed) {
      return url;
    }

    return `/iframe-wrapper${url}`;
  };

  const navigationObjectToTopLevelNavigation = (navObject: any): TopLevelNavigation => {
    const topMenuItems: TopLevelNavigation = [];
    Object.entries(navObject).forEach(([key, value]) => {
      if (Object.hasOwn(navObject, key)) {
        if (!Array.isArray(value)) return;
        if (key === 'Unused_Items') return;
        const parentUuid = crypto.randomUUID();

        const childItems: Array<SidebarMenuItem> = [];
        (value as Array<any>).forEach(item => {
          const isIframed = item.iframed === 1;

          // isHomePage has a bit of a hack to determine what is a home page by only doing the override to items that
          // title matches their folder and are first in the sort order. This allows us to have pages named the same as
          // their header menu.
          const menuItem: SidebarMenuItem = {
            label: item.mui_title?.replace('&amp;', '&'),
            uuid: crypto.randomUUID(),
            systemId: item.mui_menu_system_autoinc,
            isHomePage: item.mui_title === item.mui_folder && item.mui_order < 2,
            isIframed: isIframed,
            url: generateUrl(isIframed, item.mui_url),
            originalUrl: generateUrl(isIframed, item.mui_url),
            parentUuid: parentUuid,
            rootView: item.mui_root_view,
          };

          menuItem.command = () => AppStore.setActiveSubPage(menuItem);

          if (key === 'Sales') {
            if (menuItem.label === 'Accounts' || menuItem.label === 'Contacts' || menuItem.label === 'Documents' || menuItem.label === 'Leads' || menuItem.label === 'Opportunities' || menuItem.label === 'Activities') {
              menuItem.routingCommand = () => router.push({ path: `/crm/${menuItem.label.toLowerCase()}` });
            }
          }

          // The Manage Measurements screen is vue-routed so its inventory detail
          // flyout has a RouterView host to render into.
          if (menuItem.rootView === 'manageMeasurements') {
            menuItem.routingCommand = () => router.push({ path: '/measurements' });
          }

          childItems.push(menuItem);
        });

        if (!childItems.find(item => item.isHomePage)) {
          const homeItem: SidebarMenuItem = {
            label: 'Home',
            uuid: crypto.randomUUID(),
            url: '',
            systemId: -1,
            parentUuid: parentUuid,
            isHomePage: true,
            isCategoryHome: true,
          };

          homeItem.command = () => {
            AppStore.setActiveSubPage(homeItem);
            AppStore.showPageNotImplemented = false;
          };
          childItems.unshift(homeItem);
        }

        const topMenuItem: TopLevelNavigationItem = {
          label: key,
          uuid: parentUuid,
          children: childItems,
        };

        if (key === 'CORE') {
          topMenuItem.shouldShowSidebar = false;
        } else {
          topMenuItem.shouldShowSidebar = true;
        }

        topMenuItem.command = () => AppStore.setActivePage(topMenuItem);

        topMenuItems.push(topMenuItem);
      }
    });

    return topMenuItems;
  };

  return { navigationObjectToTopLevelNavigation };
};
